<template>
    <Interval
        :title="$t('yoga' + yoga.number) + ' (' + yoga.lord + ')'"
        :description="yoga.number + $t('yoga') 
          + ' / ' + formatTime(yoga.start) + ' - ' + formatTime(yoga.end)
          + ' / ' + yoga.diety"
        :bg="'bg-'+yoga.lord.toLowerCase()" :favorable="yoga.favorable"
        :start="yoga.start" :length="yoga.length"
        :scale="scale" :zero="zero" :visibleLeft="visibleLeft"
    />
</template>

<script>
import Interval from '@/components/panchanga/Interval'
import { TimeFormatMixin } from '@/components/visual/TimeFormatMixin'

export default {
  props: ['yoga', 'scale', 'zero', 'visibleLeft'],
  components: { Interval },
  mixins: [TimeFormatMixin],
}
</script>

<i18n locale="ru" lang="yaml">
  yoga: "-я йога"
  yoga1: "Вишкумбха"
  yoga2: "Прити"
  yoga3: "Аюшман"
  yoga4: "Саубхагья"
  yoga5: "Шобхана"
  yoga6: "Атиганда"
  yoga7: "Сукарма"
  yoga8: "Дхрити"
  yoga9: "Шула"
  yoga10: "Ганда"
  yoga11: "Вриддхи"
  yoga12: "Дхрува"
  yoga13: "Вьягхата"
  yoga14: "Харшана"
  yoga15: "Ваджра"
  yoga16: "Сиддхи"
  yoga17: "Вьятипата"
  yoga18: "Варияна"
  yoga19: "Паригха"
  yoga20: "Шива"
  yoga21: "Сиддха"
  yoga22: "Садхья"
  yoga23: "Шубха"
  yoga24: "Шукла"
  yoga25: "Брахма"
  yoga26: "Индра"
  yoga27: "Вайдхрити"
  diety: "Покровитель"
</i18n>

<i18n locale="en" lang="yaml">
  yoga: " yoga"
  yoga1: "Vishkumbha"
  yoga2: "Priti"
  yoga3: "Ayushman"
  yoga4: "Saubhagya"
  yoga5: "Shobhana"
  yoga6: "Atiganda"
  yoga7: "Sukarma"
  yoga8: "Dhriti"
  yoga9: "Shula"
  yoga10: "Ganda"
  yoga11: "Vriddhi"
  yoga12: "Dhruva"
  yoga13: "Vyaghata"
  yoga14: "Harshana"
  yoga15: "Vajra"
  yoga16: "Siddhi"
  yoga17: "Vyatipata"
  yoga18: "Variyana"
  yoga19: "Parigha"
  yoga20: "Shiva"
  yoga21: "Siddha"
  yoga22: "Sadhya"
  yoga23: "Shubha"
  yoga24: "Shukla"
  yoga25: "Brahma"
  yoga26: "Indra"
  yoga27: "Vaidhriti"
  diety: "Diety"
</i18n>
